import { useTranslation } from "react-i18next";
import ActionsPerformanceDataExplorerFields from "./ActionsPerformanceDataExplorerFields";

const ActionsPerformanceDataExplorerFieldsPanel = ({
  fields,
  onUpdateFieldFilter,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-row gap-x-1">
      <ActionsPerformanceDataExplorerFields
        label={t(
          "dataExplorers.actionsPerformance.metricsAndDimensions.dimensions.title",
        )}
        fields={fields.filter((field) => field.type === "dimension")}
        onUpdateFieldFilter={(field) => onUpdateFieldFilter(field, "dimension")}
      />
      <ActionsPerformanceDataExplorerFields
        label={t(
          "dataExplorers.actionsPerformance.metricsAndDimensions.metrics.title",
        )}
        fields={fields.filter((field) => field.type === "metric")}
        onUpdateFieldFilter={(field) => onUpdateFieldFilter(field, "metric")}
      />
    </div>
  );
};

export default ActionsPerformanceDataExplorerFieldsPanel;
